import "./public-path";
import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Provider } from "react-redux";
import { ConfigProvider } from "antd";
import zhCN from "antd/es/locale/zh_CN";
import { StyleProvider,legacyLogicalPropertiesTransformer } from '@ant-design/cssinjs';
import "@/utils/rem";

import "@/assets/style/index.less";
// redux
import store from "./stores";

// router
import { rootRoutes, renderRoutes } from "@/routes";
import { reflectRouter } from "./utils/reflectH5";
import { getServiceVal } from "./utils/cookies";
const ISMOBILE = function () {
  const flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag;
};

let root: ReactDOM.Root;

function render(props: any) {
  const { container } = props;
  root = ReactDOM.createRoot(container ? container.querySelector("#root") : document.querySelector("#root"));
  root.render(
    <Provider store={store}>
      <StyleProvider hashPriority="high"  transformers={[legacyLogicalPropertiesTransformer]}>
      <ConfigProvider  locale={zhCN}>
        
        <Suspense>
          <BrowserRouter basename="/">
            <Routes>
              {renderRoutes(rootRoutes)}
              <Route path="/questions" element={<Navigate to="/technicalSupport/questions" replace />}></Route>
            </Routes>
            
          </BrowserRouter>
        </Suspense>
       
      </ConfigProvider>
       </StyleProvider>
    </Provider>
  );
}

const IS_CSDN_LOGIN = new URLSearchParams(window.location.search).get('login') === 'from_csdn'
if (IS_CSDN_LOGIN && !getServiceVal('Authorization')) {
  setTimeout(() => {
    // 注释：给浏览器history栈，推入一条指定的历史记录：无论用户从开鸿CSDN专区任何一个链接进入社区Developer，取消授权后，均跳转至开鸿社区Developer首页
    history.pushState(null, '', window.location.origin)
    window.open(`https://passport.csdn.net/oauth2?client_id=7b249fdc86d6cdbd16ba46d0c1f4db88&redirect_uri=${encodeURIComponent(window.location.origin)}%2Fv1%2Fapi%2Fauth%2Fauth%2Fcallback%2Fcsdn%2Fdeveloper&response_type=code&state=developer&scope=all`, '_blank')
  }, 3000)
}

/**
 * 判断手机端
 */
if (ISMOBILE()) {
  let baseUrl = window.location.origin.includes("dev-developer") ? window.location.origin.replace("dev-developer", "dev-h5developer") : "https://h5developer.kaihong.com";
  //开发环境 跳转dev
  if (process.env.NODE_ENV == "development") {
    baseUrl = "https://dev-h5developer.kaihong.com";
  }
  const pathName = reflectRouter();
  console.log(pathName);
  // window.open(`${baseUrl}${pathName}`, "_self");
  window.location.replace(`${baseUrl}${pathName}`);
} else {
  render({});
}
